exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-SearchBox__item {\n  max-height: 5rem;\n  padding: 0.5rem 1rem;\n  overflow: hidden; }\n  :last-child > .o-SearchBox__item {\n    margin-bottom: 0; }\n  .o-SearchBox__item--highlighted {\n    background: #efefef; }\n  .hover-active .o-SearchBox__item:hover,\n  .hover-active .o-SearchBox__item:focus {\n    background: #efefef; }\n\n.o-SearchBox__image {\n  width: 4rem;\n  height: 4rem;\n  padding: 4px; }\n\n.o-SearchBox__price--list {\n  text-decoration: line-through; }\n\n@media screen and (max-width: 44.9375em) {\n  .o-SearchBox__item {\n    color: #444;\n    padding: 0.5rem 0; } }\n", ""]);

// exports
